import React from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import "./DesarrolloWeb.css";

function Ecommerce() {
  return (
    <>
      <SEO
        title="E-Commerce | WooCommerce y PrestaShop"
        description="Tiendas online optimizadas para vender con WooCommerce y PrestaShop."
        url="https://juancarlosmancharamos.ar/ecommerce"
      />

      <Menu />

      <HeroInner
        title="E-Commerce"
        subtitle="Tiendas online optimizadas para vender"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <h2>Tiendas online que convierten</h2>

        <p>
          Desarrollo e-commerce con WooCommerce y PrestaShop enfocados en ventas,
          rendimiento y experiencia de usuario.
        </p>

        <p>
          Integración con medios de pago, envíos, automatizaciones y CRM.
        </p>

        <h3>Optimización para ventas</h3>

        <p>
          Diseño orientado a conversión, velocidad de carga y SEO para atraer
          tráfico orgánico.
        </p>
      </section>

      <section id="abt-lnk" className="center-first">
        <div className="container text-center">
          <h2>+ servicios</h2>
          <Services />
        </div>
      </section>

      <ChatBot />
      <GlobalScripts />
    </>
  );
}

export default Ecommerce;